export const SCHEDULE_MEETING_TYPES = [
  'interview',
  'consultation',
  'intro_call',
  'general_meeting',
  'weekly_sync',
  'monthly_sync',
  'toe_touch',
  'vacation',
  'out_of_office',
] as const;

export type ScheduleMeetingType = (typeof SCHEDULE_MEETING_TYPES)[number];

export const SCHEDULE_MEETING_TYPE_LABELS: Record<ScheduleMeetingType, string> = {
  interview: 'Interview',
  consultation: 'Consultation',
  intro_call: 'Onboarding Kickoff',
  general_meeting: 'General Meeting',
  weekly_sync: 'Weekly Sync',
  monthly_sync: 'Monthly Sync',
  toe_touch: 'Toe-Touch',
  vacation: 'Vacation',
  out_of_office: 'Out of Office',
};

export const SCHEDULE_MEETING_TYPE_DESCRIPTIONS: Record<
  ScheduleMeetingType,
  string
> = {
  interview: 'Interview scheduling for hiring stages.',
  consultation: 'Lead consultation and discovery calls.',
  intro_call: 'Foundational onboarding kickoff for client context, goals, constraints, and first-project direction.',
  general_meeting: 'General planning and project meetings.',
  weekly_sync: 'Weekly status sync with stakeholders.',
  monthly_sync: 'Monthly strategy and KPI review.',
  toe_touch: 'Quick touchpoint and unblock check-in.',
  vacation: 'Host is on vacation and unavailable.',
  out_of_office: 'Host is out of office and unavailable.',
};

export const SCHEDULE_MEETING_TYPE_COLORS: Record<ScheduleMeetingType, string> = {
  interview: '#38bdf8',
  consultation: '#10b981',
  intro_call: '#6366f1',
  general_meeting: '#3b82f6',
  weekly_sync: '#a855f7',
  monthly_sync: '#f59e0b',
  toe_touch: '#ef4444',
  vacation: '#a64c44',
  out_of_office: '#6b7280',
};

export const SCHEDULE_MEETING_TYPE_ICONS: Record<ScheduleMeetingType, string> = {
  interview: 'R',
  consultation: 'C',
  intro_call: 'I',
  general_meeting: 'G',
  weekly_sync: 'W',
  monthly_sync: 'M',
  toe_touch: 'T',
  vacation: 'V',
  out_of_office: 'O',
};
